import { ApplicationRef, ComponentFactoryResolver, EmbeddedViewRef, Injectable, Injector } from '@angular/core';
import * as _ from 'lodash';
import { ImageFullscreenComponent } from '../main/product-detail/image-fullscreen/image-fullscreen.component';
import { ProductModel, ProductTypeModel } from '../model/product.model';

@Injectable({
  providedIn: 'root'
})
export class HelperService {
  imageFullscreenRef;

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private appRef: ApplicationRef,
    private injector: Injector
  ) {
  }

  removeIdFromObject(obj) {
    const req = {};
    for (const key in obj) {
      if (key === 'id') {
        continue;
      }
      if (typeof key === 'object' && obj[key] && obj[key].id) {
        continue;
      }
      req[key] = obj[key];
    }
    return req;
  }

  goFullscreenMode(img) {
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(ImageFullscreenComponent);
    const componentRef = componentFactory.create(this.injector);
    this.appRef.attachView(componentRef.hostView);

    const domElem = (componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
    document.body.appendChild(domElem);
    this.imageFullscreenRef = componentRef;
    this.imageFullscreenRef.instance.src = img;
    this.imageFullscreenRef.instance.close.subscribe(() => {
      setTimeout(() => {
        this.appRef.detachView(this.imageFullscreenRef.hostView);
        this.imageFullscreenRef.destroy();
      }, 200);
    });

    return this.imageFullscreenRef;
  }

  sortByName(list) {
    return list.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase(), undefined, {
      numeric: true,
      sensitivity: 'base'
    }));
  }

  sortProductParams(list) {
    return list.sort((a, b) => {
      if (!a || !b || !a.productType || !b.productType) {
        return 1;
      }
      return a.productType.name.toLowerCase().localeCompare(b.productType.name.toLowerCase(), undefined, {
        numeric: true,
        sensitivity: 'base'
      });
    });
  }

  generateProductCode(type: ProductTypeModel, products) {
    const acronym = type.name.split(/\s/).reduce((res, word) => res += word.slice(0, 1), '').toUpperCase();

    const productsSameType = products.filter(item => item.productTypeId === type.id);
    const numberCode = ('0' + (productsSameType.length + 1)).slice(-2);

    return `${acronym}${numberCode}`;
  }

  checkProductCodeExisted(value, products: Array<ProductModel>, selectedProductId) {
    for (let i = 0; i < products.length; i++) {
      const product = products[i];
      if (product.code === value.code && product.name !== value.name && product.id !== selectedProductId) {
        return true;
      }
    }
    return false;
  }

  removeUnicode(str: string): string {
    if (!str) {
      return '';
    }

    let result = str;

    result = result.toLowerCase();
    result = result.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a');
    result = result.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e');
    result = result.replace(/ì|í|ị|ỉ|ĩ/g, 'i');
    result = result.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o');
    result = result.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u');
    result = result.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y');
    result = result.replace(/đ/g, 'd');
    result = result.replace(/!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'| |\"|\&|\#|\[|\]|~|$|_/g, '-');
    result = result.replace(/-+-/g, '-');
    result = result.replace(/\-/g, ' ');
    result = result.replace(/^\-+|\-+$/g, '');

    return result.trim();
  }


}
